import { useEffect, useState, useRef } from "react";
//-------------------------------------------
import Resize from "src/components/common/resize";
import { useMyStore } from "src/components/main/mainStore";
import {
    myAxios, 
    MyDate, 
    getDatefromWeekNum, 
    MyFormData, 
    onlyUnique, 
    Select, 
    arrayReducer, 
    fleetUsageStartWeeks as weeks,
    appTitle
} from "src/components/common/functions";
import Chart from "./chart";
//-------------------------------------------
// this is for project stage color:
// 255, 99, 132 red
// 54, 162, 235 blue
// 255, 206, 86 yellow
// 75, 192, 192 green
// 153, 102, 255 purple
// 255, 159, 64 orange
// 127, 188, 65 grass green
// 50, 136, 189 dark blue
// 94, 79, 162 dark purple
//purchase category color 7 out of 9
//-------------------------------------------
// max: Math.max(
//     (tc[tc.length - 1]?.[1] ?? 0), 
//     p[p.length - 1]?.[1] ?? 0, 
//     pur[pur.length - 1]?.[1] ?? 0,
//     b[b.length - 1]?.[1] ?? 0,
//     profit[profit.length - 1]?.[1] ?? 0
// ) * 1.1
//-------------------------------------------
export default function TrailerUsage({ tabTitle }){
    const user = useMyStore(state => state.user);
    /*
    '156', 
    '161', 
    '165', 
    '167', 
    '170',  
    '177', 
    '180', 
    '187', 
    '192', 

    '162',
    '200', 
    '201',

    '169', 
    '171',  
    '173', 
    '174', 
    '175', 
    */
    const myChart = useRef(null);
    const onComplete = () => {
        var chartInstance = myChart.current.chart,
        ctx = chartInstance.ctx;
        ctx.font = Chart.helpers?.fontString(Chart.defaults.global.defaultFontSize, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily) ?? ctx.font;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'bottom';
        myChart.current.data.datasets.forEach((dataset, i) => {
            var meta = chartInstance.controller.getDatasetMeta(i);
            meta.data.forEach(function(bar, index){
            var data = dataset.data[index];
            if(data > 0){
                ctx.fillText(data, bar._model.x, bar._model.y - 5);
            }
            });
        });
    }
    const opt = [
        [255, 99, 132], 
        [54, 162, 235], 
        [255, 206, 86], 
        [75, 192, 192], 
        [153, 102, 255], 
        [255, 159, 64], 
        [127, 188, 65], 
        [50, 136, 189],
        [94, 79, 162],
    ];
    //-------------------------------------------------------------------------
    const [week, setWeek] = useState("");
    const [active, setActive] = useState("");
    const [showLoading, setShowLoading] = useState(false);
    const [singleTruckNumbers, setSingleTruckNumbers] = useState([]);
    const [singleData, setSingleData] = useState({});
    const [truckNumbers, setTruckNumbers] = useState([]);
    const [data, setData] = useState([]);
    const [truckNumber, setTruckNumber] = useState([].map(v => ({label: v, value: v})) ?? []);
    const [month, setMonth] = useState("");
    //-------------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const getData = async() => {
            const formData = new MyFormData();
            //-------------------------------------------------------------------------
            setShowLoading(true);
            const resTruckNumbers = await myAxios("fleetUsage/readTrailerNumbersOnly.php", formData);
            if(!isMounted) return;
            setShowLoading(false);
            if(!resTruckNumbers) return;
            //-------------------------------------------------------------------------
            setTruckNumbers(resTruckNumbers.data.map(truckNumber => ({label: truckNumber, value: truckNumber})));
            //-------------------------------------------------------------------------
            setShowLoading(true);
            const resTruckNumber = await myAxios("fleetUsage/readTrailerNumber.php", formData);
            if(!isMounted) return;
            setShowLoading(false);
            if(!resTruckNumber) return;
            //-------------------------------------------------------------------------
            setTruckNumber(resTruckNumber.data);
        }
        getData();
        return () => {isMounted = false;}
    }, [])
    useEffect(() => {
        let isMounted = true;
        if(!truckNumber.length || !month || active !== "Month") return;
        const getData = async() => {
            const formData = new MyFormData();
            formData.append("month", month);
            formData.append("data", "(" + truckNumber.map(option => "\"" + option.value + "\"").join(", ") + ")");
            //-------------------------------------------------------------------------
            setShowLoading(true);
            const resData = await myAxios("fleetUsage/readTrailerByMonth.php", formData);
            if(!isMounted) return;
            setShowLoading(false);
            if(!resData) return;
            //-------------------------------------------------------------------------
            setData(resData.data);
        }
        getData();
        return () => {isMounted = false;}
    }, [active, month, truckNumber])
    useEffect(() => {
        let isMounted = true;
        if(!truckNumber.length || !week || active !== "Week") return;
        const getData = async() => {
            const formData = new MyFormData();
            formData.append("startDate", getDatefromWeekNum(week, 0));
            formData.append("endDate", getDatefromWeekNum(week, 6));
            formData.append("data", "(" + truckNumber.map(option => "\"" + option.value + "\"").join(", ") + ")");
            //-------------------------------------------------------------------------
            setShowLoading(true);
            const resData = await myAxios("fleetUsage/readTrailerByWeek.php", formData);
            if(!isMounted) return;
            setShowLoading(false);
            if(!resData) return;
            //-------------------------------------------------------------------------
            setData(resData.data);
        }
        getData();
        return () => {isMounted = false;}
    }, [active, week, truckNumber])
    useEffect(() => {
        let isMounted = true;
        if(!singleTruckNumbers.length) return;
        const getData = async() => {
            const formData = new MyFormData();
            formData.append("data", "(" + singleTruckNumbers.map(option => "\"" + option.value + "\"").join(", ") + ")");
            //-------------------------------------------------------------------------
            setShowLoading(true);
            const resData = await myAxios("fleetUsage/readSingleVechileByMonth.php", formData);
            if(!isMounted) return;
            setShowLoading(false);
            if(!resData) return;
            //-------------------------------------------------------------------------
            const tns = resData.data.map(a => a.preTruckNumber).filter(onlyUnique);
            const output = {};
            for(let i = 0; i < tns.length; i++){
                const tn = tns[i];
                const obj = {};
                const data = resData.data.filter(a => a.preTruckNumber === tn).map(a => a.startTime).filter(onlyUnique);
                data.forEach(startTime => {
                    const month = startTime.slice(0, 7);
                    if(!(month in obj)){
                        obj[month] = data.filter(item => item.startsWith(month)).length;
                    }
                });
                output[tn] = obj;
            }
            const keys = resData.data.map(a => a.startTime.slice(0, 7)).filter(onlyUnique).sort();
            const min = keys[0];
            const max = keys[keys.length - 1];
            // return;
            let cur = min;// work from here
            while(cur !== max){
                //-------------------------------
                const curYear = cur.slice(0, 4);
                const curMonth = cur.slice(5, 7);
                const nextYear = curMonth === "12"?(window.parseInt(curYear) + 1).toString():curYear;
                let nextMonth = window.parseInt(curMonth) + 1;
                if(nextMonth > 0 && nextMonth < 10){
                    nextMonth = "0" + nextMonth.toString();
                }else if(nextMonth >= 10 && nextMonth <= 12){
                    nextMonth = nextMonth.toString();
                }else if(nextMonth === 13){
                    nextMonth = "01";
                }
                cur = nextYear + "-" + nextMonth;
                //-------------------------------
                for(const key in output){
                    if(!(cur in output[key])){
                        output[key][cur] = 0;
                    }
                }
            }
            for(const key in output){
                output[key] = Object.entries(output[key]).sort((a, b) => a[0] > b[0]? 1 : -1)
              
            }
            setSingleData(output);
        }
        getData();
        return () => {isMounted = false;}
    }, [singleTruckNumbers])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //-------------------------------------------------------------------------
    return (
    <div>
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    {tabTitle}
                </span>
            </div>
            <div className = "cssContent pb10">
                {showLoading?
                <div className = "cssLoading">Loading...</div>:
                <>
                    <div className = "d-flex align-items-center mb-3">
                        <label className = "mb-0 mr-2 alignSelf-center">Mode</label>
                        <select
                            required
                            className = "mr-3 form-control inline"
                            value = {active}
                            onChange = {e => setActive(e.currentTarget.value)}
                        >
                            <option value = "">Select</option>
                            <option>Week</option>
                            <option>Month</option>
                        </select>
                        {active === "Month"?
                        <input
                            required
                            className = {"form-control inline"}
                            type = "month"
                            max = {(new MyDate()).s().slice(0, 7)}
                            value = {month}
                            onChange = {e => setMonth(e.currentTarget.value)}
                        />
                        :<></>}
                        {active === "Week"?
                        <select
                            required
                            className = {"form-control inline"}
                            value = {week}
                            onChange = {e => setWeek(e.currentTarget.value)}
                        >
                            <option value = {""}>Select</option>
                            {weeks.map((wk, key) => <option key = {key}>{wk}</option>)}
                        </select>
                        :<></>}
                    </div>
                    <div className = "d-flex align-items-center">
                        <label className = "mb-0 alignSelf-center">Trailers</label>
                        <div className = "mx-3 flex-grow-1">
                            <Select
                                isMulti
                                value = {truckNumber}
                                onChange = {async e => {
                                    setTruckNumber(e);
                                    const formData = new MyFormData();
                                    formData.append("data", JSON.stringify(e));
                                    //-------------------------------------------------------------------------
                                    setShowLoading(true);
                                    const resTruckNumber = await myAxios("fleetUsage/updateTrailerNumber.php", formData);
                                    setShowLoading(false);
                                    if(!resTruckNumber) return;
                                    //-------------------------------------------------------------------------
                                }}
                                options = {truckNumbers}
                            />
                        </div>
                    </div>
                    {((active === "Month" && month) || (active === "Week" && week)) && truckNumber.length?
                    <div className = "flex-grow-1">
                        <Chart
                            myChart = {myChart}
                            chartConfig = {{
                                type: "bar",
                                data: {
                                    labels: truckNumber.map(t => t.value),
                                    datasets: truckNumber.map(t => ({label: t.label, data: data.filter(item => item.trailerNumber === t.value).map(item => item.startTime).filter(onlyUnique).length}))
                                    .map((item, itemIndex) => 
                                        ({   
                                            data: [...Array(itemIndex).fill(0), (item.data)],
                                            label: item.label,
                                            backgroundColor: `rgba(${opt[itemIndex % 9].join(", ")}, 0.5)`,
                                            borderColor: `rgba(${opt[itemIndex % 9].join(", ")}, 1)`,
                                            fill: false
                                        })
                                    )
                                },
                                options: {
                                    animation: { onComplete  },
                                    hover: {
                                        animationDuration: 0
                                    },
                                    // tooltips: {
                                    //     enabled: false
                                    // },
                                    legend: {
                                        display: true
                                    },
                                    title: {
                                        fontSize: 20,
                                        display: true, 
                                        text: `Fleet Usage on ${active === "Month"?month:""}${active === "Week"?`${week} (${getDatefromWeekNum(week, 0)} ~ ${getDatefromWeekNum(week, 6)})`:""}`
                                    },
                                    scales: {
                                        xAxes: [{
                                            stacked: true, 
                                            scaleLabel: {
                                                fontSize: 15,
                                                display: true,
                                                labelString: "Vehicle"
                                            }
                                        }],
                                        yAxes: [{
                                            stacked: true, 
                                            ticks: {
                                                max: Math.ceil(1.1 * Math.max(...truckNumber.map(t => ({label: t.label, data: data.filter(item => item.trailerNumber === t.value).map(item => item.startTime).filter(onlyUnique).length})).map(a => a.data))), 
                                                beginAtZero: true, 
                                                callback: value => {if(value % 1 === 0) return value;}
                                            },
                                            scaleLabel: {
                                                fontSize: 15,
                                                display: true,
                                                labelString: "Number of Times"
                                            },
                                        }]
                                    } 
                                }
                            }}
                        />
                    </div>
                    :null}
                    <div className = "mt-4 d-flex align-items-center">
                        <label className = "mb-0  alignSelf-center">Trailers</label>
                        <div className = "mx-3 flex-grow-1">
                            <Select
                                isMulti
                                value = {singleTruckNumbers}
                                onChange = {e => {
                                    setSingleTruckNumbers(e);
                                }}
                                options = {truckNumbers}
                            />
                        </div>
                    </div>
                    {singleTruckNumbers.length?
                    <div className = "flex-grow-1">
                        <Chart
                            myChart = {myChart}
                            chartConfig = {{
                                type: "line",
                                data: {
                                    labels: Object.values(singleData)[0]?.map(item => item[0]),
                                    datasets:  
                                    Object.entries(singleData).map((entry, entryIndex) => ({
                                        label: entry[0],
                                        data: entry[1].map(item => item[1]),
                                        tension: 0,
                                        fill: false,
                                        backgroundColor: `rgba(${opt[entryIndex % 9].join(", ")}, 0.5)`,
                                        borderColor: `rgba(${opt[entryIndex % 9].join(", ")}, 1)`,
                                    }))
                                },
                                options: {
                                    hover: {
                                        animationDuration: 0
                                    },
                                    // tooltips: {
                                    //     enabled: false
                                    // },
                                    legend: {
                                        display: true
                                    },
                                    title: {
                                        fontSize: 20,
                                        display: true, 
                                        text: "Fleet Usage"
                                    },
                                    scales: {
                                        xAxes: [{
                                            scaleLabel: {
                                                fontSize: 15,
                                                display: true,
                                                labelString: "Month"
                                            }
                                        }],
                                        yAxes: [{
                                            ticks: {
                                                max: Math.ceil(1.1 * Math.max(...Object.values(singleData).reduce(arrayReducer, []).map(item => item[1]))), 
                                                beginAtZero: true,
                                                callback: value => {if(value % 1 === 0) return value;} 
                                            },
                                            scaleLabel: {
                                                fontSize: 15,
                                                display: true,
                                                labelString: "Number of Times"
                                            }
                                        }]
                                    } 
                                }
                            }}
                        />
                    </div>
                    :null}
                </>}
            </div>
        </div>    
    </div>
    )
}
// SELECT `truckNumber`, COUNT(`truckNumber`) FROM `billings` GROUP BY `truckNumber` HAVING COUNT(`truckNumber`) > 1;
// 02ce320ea6b92a252ce405e67ea11fc2